import React, { useEffect, useState } from "react";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../store/adminData/adminData";
import { uploadImage } from "../../../../services/firebaseService/endPoints/admin/members";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../services/firebaseService/connection";
import dayjs from "dayjs";
import { Alert, Divider, Input, Modal, Tag } from "antd";
import ImageUploadButton from "../../website/ImageUploaderButton";
import { ChantInput, HelpTooltip } from "../../../../CommonComponents";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import ChantSpinner from "../../../../CommonComponents/ChantSpinner/ChantSpinner";
import GetStarted from "../GetStarted";
import DirectoryGeneral from "../directory-general";
import DirectoryImages from "../directory-images";
import CreateLocations from "../../locations/CreateLocation/CreateLocations";
import { getWebsiteConfig } from "../../../../services/firebaseService/endPoints/admin/website";
import {
  GUIDE_GROW,
  TOPIC_PUBLISH_GROUP,
} from "../../../../constants/gettingStarted";
import { getLocations } from "../../../../services/firebaseService/endPoints/admin/content";
import "./GroupListing.css";
import DescriptionText from "../../../../CommonComponents/DescriptionText";
import { chantApi } from "../../../../utils/chantApi";

const GroupListing = ({ handleTabChange }) => {
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const setGettingStartedExpanded = useAdminDataStore(
    (state) => state.setGettingStartedExpanded,
  );
  const setGettingStartedItemStatus = useAdminDataStore(
    (state) => state.setGettingStartedItemStatus,
  );

  const [formData, setFormData] = useState({
    isLoading: false,
    photo: null,
    locations: [],
    selectedLocations: [],
    watchparty: {
      image: null,
      locationData: {
        placeId: "",
        address: "",
        latitude: 33.7676338,
        longitude: -84.5606888,
      },
    },
    tailgate: {
      image: null,
      locationData: {
        placeId: "",
        address: "",
        latitude: 33.7676338,
        longitude: -84.5606888,
      },
    },
    contact: {
      website: "",
      email: "",
      facebook: "",
      insta: "",
      twitter: "",
      linktree: "",
    },
    general: {},
    groupImages: { image1: "", image2: "", image3: "", image4: "" },
    summary: "",
    groupOverview: "",
    locationType: "",
    tab: "directory",
    isSaving: false,
    showModal: false,
    showWelcomeModal: false,
    errorInForm: {
      isError: false,
      visible: false,
      message: "",
    },
    isPublished: false,
    groupLink: "",
  });

  const handleErrorMessageClose = () => {
    setFormData((prev) => ({
      ...prev,
      errorInForm: {
        ...prev.errorInForm,
        visible: false,
      },
    }));
  };

  const handleInputChange = (e) => {
    if (e.target.name.includes(".")) {
      const [parent, child] = e.target.name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: e.target.value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleModalChange = () => {
    setFormData((prev) => ({
      ...prev,
      showModal: !prev.showModal,
    }));
  };

  const handleOptionChange = (e) => {
    if (e.target.name.includes(".")) {
      const [parent, child] = e.target.name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: e.target.value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleImageChange = (key, image) => {
    const obj = { ...formData.groupImages };
    obj[key] = image;
    setFormData((prev) => ({
      ...prev,
      groupImages: obj,
    }));
  };

  const handleDeleteLocation = (index) => {
    let selectedLocations = formData.selectedLocations;
    selectedLocations.splice(index, 1);

    setFormData((prev) => ({
      ...prev,
      selectedLocations,
    }));
  };

  const processSocialHandles = (handle, platform) => {
    if (!handle || handle.trim() === "") {
      return "";
    }

    let result = handle.trim();

    if (result.startsWith("@")) {
      result = result.substring(1);
    }

    if (result.startsWith("https://")) {
      return result;
    }

    switch (platform) {
      case "instagram":
        return `https://instagram.com/${result}`;
      case "facebook":
        return `https://facebook.com/${result}`;
      case "twitter":
        return `https://twitter.com/${result}`;
      case "linktree":
        return `https://linktr.ee/${result}`;
      default:
        return result;
    }
  };

  const fetchData = async () => {
    setFormData((prev) => ({ ...prev, isLoading: true }));
    try {
      const data = await getWebsiteConfig(groupData?.id);
      if (data) {
        let stateObj = {
          summary: data.groupSummary || "",
          groupOverview: data.groupOverview || "",
          contact: {
            ...(data.social || {}),
            ...(data.contact || {}),
          },
          groupImages: data?.configuration?.groupImages
            ? data?.configuration?.groupImages
            : { image1: "", image2: "", image3: "", image4: "" },
          photo: data.configuration ? data.configuration.photo : "",
          general: {
            ...data.general,
            clubStatus: data.groupType,
            groupSize: (data.general || {}).size,
          },
          selectedLocations:
            (data.sections && data.sections.selectedLocations) || [],
          isPublished: data?.isPublished || false,
          groupLink: data?.isPublished
            ? `https://directory.chant.fan/details/${groupData?.id}`
            : "",
        };

        if (data?.isPublished) {
          setGettingStartedItemStatus(
            groupData?.id,
            GUIDE_GROW,
            TOPIC_PUBLISH_GROUP,
            true,
          );
        }

        let locations = await getLocations(groupData?.id);

        setFormData((prev) => ({
          ...prev,
          ...stateObj,
          locations,
          isLoading: false,
        }));
      } else {
        setFormData((prev) => ({ ...prev, isLoading: false }));
      }
    } catch {
      setFormData((prev) => ({ ...prev, isLoading: false }));
    }
  };

  useEffect(() => {
    if (groupData?.id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData?.id]);

  const handleSubmit = async () => {
    try {
      setFormData((prev) => ({
        ...prev,
        isSaving: true,
      }));

      if (!formData.summary) {
        setFormData((prev) => ({
          ...prev,
          errorInForm: {
            isError: true,
            visible: true,
            message: "Summary is required.",
          },
          isSaving: false,
        }));
        window.scrollTo(0, 0);
        return;
      }
      if (formData.selectedLocations.length === 0) {
        setFormData((prev) => ({
          ...prev,
          errorInForm: {
            isError: true,
            visible: true,
            message: "Please add location(s) to Where We Meet.",
          },
          isSaving: false,
        }));
        window.scrollTo(0, 0);
        return;
      }

      let websiteData = {
        sections: {
          selectedLocations: [],
        },
        groupSummary: formData.summary,
        groupOverview: formData.groupOverview,
        social: {
          facebook: processSocialHandles(formData.contact.facebook, "facebook"),
          insta: processSocialHandles(formData.contact.insta, "instagram"),
          twitter: processSocialHandles(formData.contact.twitter, "twitter"),
          linktree: processSocialHandles(formData.contact.linktree, "linktree"),
        },
        groupType: formData.general.clubStatus,
        general: {
          founded: formData.general.founded,
          size: formData.general.groupSize,
          membershipFee: formData.general.membershipFee,
        },
        contact: {
          email: formData.contact.email,
          website: formData.contact.website
            ? formData.contact.website.startsWith("https://")
              ? formData.contact.website
              : `https://${formData.contact.website}`
            : "",
        },
        showGroup: true,
        directoryStatus: "live",
        needsReview: true,
      };

      const storageDirectory = `${groupData?.id}/profile`;

      let photo = formData.photo;

      if (photo && typeof photo === "object") {
        photo = await uploadImage(
          formData.photo,
          `${storageDirectory}/photo.png`
        ).then(({ downloadUrl }) => downloadUrl);
      } else if (!photo) {
        setFormData((prev) => ({
          ...prev,
          errorInForm: {
            isError: true,
            visible: true,
            message: "Group Photo is required.",
          },
          isSaving: false,
        }));
        window.scrollTo(0, 0);
        return;
      }

      let imagesToUpload = { ...formData.groupImages };
      let imagePromisesArr = [];

      if (formData.groupImages) {
        Object.entries(formData.groupImages).forEach(([key, value]) => {
          if (typeof value === "object") {
            imagePromisesArr.push({
              key: key,
              promise: uploadImage(
                value,
                `${storageDirectory}/groupImage-${key}.png`
              ),
            });
          } else if (typeof value === "string") {
            imagesToUpload[key] = value;
          }
        });

        const resultMap = await Promise.all(
          imagePromisesArr.map((item) => item.promise)
        )
          .then((results) => {
            return imagePromisesArr.map((item, index) => {
              return {
                [item.key]: results[index].downloadUrl,
              };
            });
          })
          .catch(() => {
            setFormData((prev) => ({
              ...prev,
              errorInForm: {
                isError: true,
                visible: true,
                message: "Failed to upload images.",
              },
              isSaving: false,
            }));
            window.scrollTo(0, 0);
            return;
          });

        imagesToUpload = {
          ...formData.groupImages,
          ...Object.assign({}, ...resultMap),
        };
      }

      websiteData.sections.selectedLocations = formData.selectedLocations;

      let configuration = {
        photo,
        groupImages: imagesToUpload,
        logo: groupData?.configuration.logo || "",
      };

      let clubColors = {
        primaryColor: { a: "1", r: 0, g: 0, b: 0 },
        secondaryColor: { a: "1", r: 0, g: 0, b: 0 },
        stripesColor: { a: "1", r: 0, g: 0, b: 0 },
        textPrimaryColor: "#FFFFFF",
      };
      let clubId = "";
      let leagueId = "";
      let clubName = "";
      let leagueName = "";

      await getDoc(doc(db, "group", groupData?.id)).then((doc) => {
        let data = doc.data() || {};
        clubId = data.clubId || "";
        clubName = data.clubName || "";
        leagueId = data.leagueId || "";
        leagueName = data.leagueName || "";
        if (!data.configuration) {
          return getDoc(doc(db, "clubColors", data.clubId)).then((doc) => {
            if (doc.exists()) {
              var data = doc.data() || {};
              if (data !== null) {
                clubColors.primaryColor = data["color1"];
                clubColors.secondaryColor = data["color2"];
                clubColors.stripesColor = data["color3"];
              }
              configuration = {
                ...configuration,
                ...clubColors,
              };
            }
          });
        } else {
          configuration = { ...configuration };
        }
        return;
      });

      let baseUrl = `${import.meta.env.VITE_GCP_BASE_URL}/addGroupToDirectory`;
      let addProfileUrl = `${baseUrl}/addGroupProfile`;

      let addProfileReqBody = {
        groupProfile: {
          ...websiteData,
          updatedOn: dayjs().unix(),
          configuration: configuration,
          clubId: clubId,
          leagueId: leagueId,
          clubName: clubName,
          leagueName: leagueName,
          groupName: groupData?.groupName || "",
        },
        groupId: groupData?.id,
        type: "update",
      };

      await chantApi.post(addProfileUrl, addProfileReqBody);

      setFormData((prev) => ({
        ...prev,
        isSaving: false,
        isPublished: true,
        groupLink: `https://directory.chant.fan/details/${groupData?.id}`,
        tab: "getStarted",
        showWelcomeModal: true,
      }));

      setGettingStartedExpanded(true);
      handleTabChange("getStarted");
    } catch {
      setFormData((prev) => ({
        ...prev,
        isSaving: false,
      }));
    }
  };

  return (
    <div className="col">
      {formData.showModal && (
        <Modal
          open={formData.showModal}
          closable={true}
          width="150vh"
          onCancel={handleModalChange}
          footer={[]}
        >
          <CreateLocations onCloseModal={handleModalChange} />
        </Modal>
      )}

      <DescriptionText showBackground>
        <div>
          <p style={{ marginBottom: "0.5rem" }}>
            Chant offers a free global supporters{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://directory.chant.fan`}
              style={{
                color: "#007bff",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#0056b3")}
              onMouseLeave={(e) => (e.target.style.color = "#007bff")}
            >
              directory
            </a>
            . Complete the form to publish your group. Share your URL in
            social media. It can also serve as a basic group website.
          </p>
          <p>
            {groupData?.groupName} URL:{" "}
            {formData.isPublished ? (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={formData.groupLink}
                style={{
                  color: "#007bff",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => (e.target.style.color = "#0056b3")}
                onMouseLeave={(e) => (e.target.style.color = "#007bff")}
              >
                Directory
              </a>
            ) : (
              "Publish group for link"
            )}
          </p>
        </div>
      </DescriptionText>

      <div className="group-listing-content">
        {formData.isLoading ? (
          <ChantSpinner />
        ) : formData.tab === "directory" ? (
          <>
            {formData.errorInForm.isError && formData.errorInForm.visible && (
              <Alert
                message="Error"
                description={formData.errorInForm.message}
                type="error"
                closable
                afterClose={handleErrorMessageClose}
                style={{ marginBottom: 8 }}
              />
            )}

            {/* Group Profile */}
            <h5 className="group-listing-section-title">Group Profile</h5>

            <div style={{ maxWidth: 420, marginBottom: 20 }}>
              <ImageUploadButton
                label="Group Photo"
                text="Upload"
                aspectRatio={5 / 2}
                images={[formData.photo]}
                required={true}
                tooltip="Image will be cropped at an aspect ratio of 5:2."
                onSave={(images) => {
                  setFormData((prev) => ({
                    ...prev,
                    photo: images[0],
                  }));
                }}
              />
            </div>

            <div className="group-listing-textarea-col">
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                <label className="group-listing-field-label" style={{ margin: 0 }}>
                  Highlight Statement
                </label>
                <HelpTooltip text="Add a brief statement highlighting your group (First official group in..., Longest active group in..., Leading the stadium atmosphere, A diverse group open to all...)" />
              </div>
              <Input.TextArea
                style={{ fontSize: "16px" }}
                placeholder="Add brief highlight statement. Max 50 characters"
                value={formData.groupOverview}
                name="groupOverview"
                onChange={handleInputChange}
                maxLength={50}
                rows={3}
              />
              <div className="group-listing-char-count">
                {formData.groupOverview.length}/50
              </div>
            </div>

            <div className="group-listing-field-row" style={{ marginTop: 16 }}>
              <div className="group-listing-textarea-col">
                <label className="group-listing-field-label">
                  Summary <span style={{ color: "red" }}>*</span>
                </label>
                <Input.TextArea
                  style={{ fontSize: "16px" }}
                  placeholder="Provide an overview of your group. Max 1000 characters."
                  value={formData.summary}
                  name="summary"
                  onChange={handleInputChange}
                  maxLength={1000}
                  rows={4}
                  required
                />
                <div className="group-listing-char-count">
                  {formData.summary.length}/1000
                </div>
              </div>
            </div>

            <Divider />

            {/* Where We Meet */}
            <h5 className="group-listing-section-title">
              Where We Meet{" "}
              <span style={{ color: "#ff0000", fontSize: "14px" }}>*</span>
            </h5>

            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {formData.selectedLocations.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {formData.selectedLocations.map((selectedLocation, index) => (
                    <Tag
                      key={index}
                      closable
                      onClose={() => handleDeleteLocation(index)}
                      style={{ fontSize: 13, padding: "4px 10px", borderRadius: 6 }}
                    >
                      <span style={{ fontWeight: 500 }}>{selectedLocation.type}</span>
                      {": "}
                      {selectedLocation.name}
                    </Tag>
                  ))}
                </div>
              )}

              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
                {formData.selectedLocations.length === 10 ||
                formData.locations.length ===
                  formData.selectedLocations.length ? null : (
                  <select
                    value={null}
                    style={{ borderColor: "#afafaf", borderRadius: 4, padding: "4px 8px", maxWidth: 280 }}
                    onChange={(e) => {
                      if (e.target.value !== null) {
                        let value = e.target.value;
                        let location = formData.locations.find(
                          (e) => e.id === value
                        );
                        let selectedLocations = formData.selectedLocations;
                        selectedLocations.push(location);
                        setFormData((prev) => ({
                          ...prev,
                          selectedLocations,
                        }));
                      }
                    }}
                  >
                    <option key="empty" value={null} style={{ color: "#afafaf" }}>
                      Select location
                    </option>
                    {formData.locations
                      .filter(
                        (e) =>
                          formData.selectedLocations.filter(
                            (location) => e.id === location.id
                          ).length === 0
                      )
                      .map((location) => (
                        <option key={location.name} value={location.id + ""}>
                          {location.type}: {location.name}
                        </option>
                      ))}
                  </select>
                )}

                {formData.locations.length < 10 && (
                  <div
                    className="btn"
                    style={{
                      padding: "3px 15px",
                      color: "#ffffff",
                      background: "#afafaf",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setFormData((prev) => ({
                        ...prev,
                        showModal: true,
                      }));
                    }}
                  >
                    Add Location
                  </div>
                )}
              </div>
            </div>

            <Divider />

            {/* Contact */}
            <h5 className="group-listing-section-title">Contact</h5>
            <div className="group-listing-fields-grid">
              <ChantInput
                label="Website"
                name="contact.website"
                placeholder="Website (full URL)"
                onChange={handleInputChange}
                value={formData.contact.website}
              />
              <ChantInput
                label="Email"
                name="contact.email"
                placeholder="Email"
                onChange={handleInputChange}
                value={formData.contact.email}
              />
              <ChantInput
                label="Facebook"
                name="contact.facebook"
                placeholder="Facebook (full URL or username)"
                onChange={handleInputChange}
                value={formData.contact.facebook}
              />
              <ChantInput
                label="Instagram"
                name="contact.insta"
                placeholder="Instagram (full URL or username)"
                onChange={handleInputChange}
                value={formData.contact.insta}
              />
              <ChantInput
                label="Twitter"
                name="contact.twitter"
                placeholder="Twitter (full URL or username)"
                onChange={handleInputChange}
                value={formData.contact.twitter}
              />
              <ChantInput
                label="Linktree"
                name="contact.linktree"
                placeholder="Linktree (full URL or username)"
                onChange={handleInputChange}
                value={formData.contact.linktree}
              />
            </div>

            <Divider />

            <DirectoryGeneral
              general={formData.general}
              handleOptionChange={handleOptionChange}
              handleInputChange={handleInputChange}
            />

            <Divider />

            <DirectoryImages
              groupImages={formData.groupImages}
              handleImageChange={handleImageChange}
            />

            <div className="d-flex justify-content-center" style={{ padding: "16px 0" }}>
              <ChantButton
                onClick={() => {
                  handleSubmit();
                }}
                loading={formData.isSaving}
              >
                Submit
              </ChantButton>
            </div>
          </>
        ) : formData.tab === "getStarted" ? (
          <GetStarted showModal={formData.showWelcomeModal} />
        ) : null}
      </div>
    </div>
  );
};

export default GroupListing;
